import { ProductsAsVariantsConfigurationSchema } from "@redotech/redo-product-common/products-as-variants/products-as-variants-configuration";
import * as z from "zod";

export const getProductsAsVariantsConfigurations = {
  name: "getProductsAsVariantsConfigurations" as const,
  input: z.object({}),
  output: z.object({
    enabled: z.boolean(),
    configurations: z.array(ProductsAsVariantsConfigurationSchema),
  }),
};
